import { devLog } from "utils/devLog";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiGetPolicyInfo } from "utils/API/TrxNowAPI";
import { PolicyLookupSpinner } from "webapp/components/PolicyLookupSpinner";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import "./GKWMemberInformationForm.scss";
import { TextField } from "@mui/material";

const COMPLETE_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const getTodayDateString = () => {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const day = String(now.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const getDaysSincePurchase = (purchaseDateStr) => {
  const purchaseDate = new Date(`${purchaseDateStr}T00:00:00`);
  const todayDate = new Date(`${getTodayDateString()}T00:00:00`);
  return Math.floor((todayDate - purchaseDate) / (1000 * 60 * 60 * 24));
};

const isPurchaseDateCovered = (purchaseDateStr, maxDays) => {
  if (!COMPLETE_DATE_PATTERN.test(purchaseDateStr)) {
    return false;
  }

  const today = getTodayDateString();
  if (purchaseDateStr > today) {
    return false;
  }

  const daysSincePurchase = getDaysSincePurchase(purchaseDateStr);
  return daysSincePurchase < maxDays;
};

const policyMap = new Map();
export default function GKWMemberInformationForm(props) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchValue, setSearchValue] = useState(props.currState.MemberLookup.memberRef);

  const [memberNumber] = useState(props.currState.MemberLookup.memberNumber);
  const [last8Vin] = useState(props.currState.MemberLookup.last8Vin);
  const [phoneNumber] = useState(props.currState.MemberLookup.phoneNumber);
  const [firstName, setFirstName] = useState(props.context.state.FirstName);
  const [lastName, setLastName] = useState(props.context.state.LastName);
  const [firstNameInput, setFirstNameInput] = useState(props.currState.MemberLookup.firstName);
  const [lastNameInput, setLastNameInput] = useState(props.currState.MemberLookup.lastName);
  const [partnerCode, setPartnerCode] = useState(props.context.state.localGroup);

  const [searchType, setSearchType] = useState(props.currState.MemberLookup.searchType);
  const [accountInfo, setAccountInfo] = useState(undefined);
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);

  const [checkDuplicateName, setCheckDuplicateName] = useState(false);
  const [displaySelectionComponent, setDisplaySelectionComponent] = useState(false);
  const [yesHasTrouble, setYesHasTrouble] = useState(false);

  /**
   * Member Not Found Info - state is owned by parent for validation on Next
   */
  const [numberOfDays, setNumberOfDays] = useState(0);

  // useEffect(() => {
  //   onSubmit();
  //   checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  // }, []);

  // useEffect(() => {
  //   checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  // }, [contacts]);

  useEffect(() => {
    // devLog(props);
    onSubmit();
  }, []);

  useEffect(() => {
    checkDuplicateContact(props.currState.FirstName, props.currState.LastName);
  }, [contacts]);

  const onLoad = (success) => {
    if (typeof props.onLoad === "function") {
      props.onLoad(success);
      setDisplaySelectionComponent(success);
    }
  };

  const onContactInfo = (selectedCont) => {
    if (typeof props.onSelect === "function") {
      devLog("onMemberInfo selected Contact: ", selectedCont);
      props.onSelect(accountInfo, selectedCont);
      // devLog("memberInfo: " + memberInfo);
    }
  };

  //select Contact function, set selectContact to contacts => input
  //
  const onSelect = (selectedCont) => {
    devLog("onSelect selected Contact: ", selectedCont);
    setSelectedContact(selectedCont);
    onContactInfo(selectedCont);
    if (selectedCont === undefined) {
      // devLog(
      //   "selected undefined Contact: ",
      //   props.context.state.FirstName + " " + props.context.state.LastName
      // );
      setFirstName(props.context.state.FirstName);
      setLastName(props.context.state.LastName);
    } else {
      setFirstName(selectedCont.firstName);
      setLastName(selectedCont.lastName);
      // devLog(
      //   "selected defined Contact: ",
      //   sc.firstName + " " + sc.lastName
      // );
    }
  };

  // const onSelectNewContact = (contacts) => {
  //   devLog("selected Contact: ", contacts);
  //   setSelectedContact(
  //     props.currState.FirstName + " " + props.currState.LastName
  //   );
  //   devLog("New Contact Name: ", selectedContact);
  //   onMemberInfo(memberInfo, contacts);
  // };

  const onSubmit = (e) => {
    setError("");
    // e.preventDefault();
    // devLog("Execute policy search...", searchValue);

    if (policyMap.has(searchValue)) {
      onContactInfo(policyMap.get(searchValue).contacts[0], selectedContact);
      setAccountInfo(policyMap.get(searchValue).contacts[0]);
      setLoading(false);
      onLoad(true);
      return;
    }

    setLoading(true);
    //Lookup: Callout
    apiGetPolicyInfo({
      data: {
        providerRef: props.currState.providerRef,
        firstName: firstNameInput,
        lastName: lastNameInput,
        last8Vin: last8Vin,
        memberNumber: memberNumber,
        phoneNumber: phoneNumber ? phoneNumber.replace(/\D/g, "") : "",
        partnerCode: partnerCode,
        searchType: searchType,
      },
      companyParams: props.currState.currentCompanyParams,
    })
      //Lookup: Success
      .then((json) => {
        devLog("JSON", json);
        setNumberOfDays(json.data.numberOfDays);
        if (typeof json.data.memberInfo === "object" && typeof json.data.memberInfo.contacts === "object") {
          if (!json.data.error) {
            setContacts(json.data.memberInfo.contacts);
            // onContactInfo(json.data.memberInfo.contacts[0], selectedContact);
            setAccountInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setAccountInfo(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.memberInfo === "object") {
          // Account found but no contacts — allow "add new driver"
          if (!json.data.error) {
            setContacts([]);
            setAccountInfo(json.data.memberInfo);
            onLoad(true);
          } else {
            setContacts([]);
            setAccountInfo(undefined);
            setError(json.data.error.message);
            onLoad(false);
          }
        } else if (typeof json.data.error === "object") {
          setContacts([]);
          setAccountInfo(undefined);
          setError(json.data.error.message);
          policyMap.delete(searchValue);
          onLoad(false);
        } else {
          setContacts([]);
          setAccountInfo(undefined);
          setError(t("BWC.PolicyInformation.UnableToFindMember"));
          policyMap.delete(searchValue);
          onLoad(false);
        }
        setLoading(false);
      })

      //Lookup: Failed
      .catch((e) => {
        devLog("error", e);
        setLoading(false);
        setContacts([]);
        setError(t("BWC.PolicyInformation.UnableToFindMember"));
        onLoad(false);
      });
  };
  const onUserBack = (e) => {
    e.preventDefault();
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const checkDuplicateContact = (firstName, lastName) => {
    let isDuplicate = false;
    if (firstName !== "" && lastName !== "" && contacts.length > 0) {
      isDuplicate = contacts.some(
        (con) =>
          con.firstName.toUpperCase().trim() === firstName.toUpperCase().trim() &&
          con.lastName.toUpperCase().trim() === lastName.toUpperCase().trim(),
      );
    }
    setCheckDuplicateName(isDuplicate);
  };

  const onClickYesHasTrouble = () => {
    const nextHasTrouble = !yesHasTrouble;
    setYesHasTrouble(nextHasTrouble);
    if (typeof props.onHavingTroubleChange === "function") {
      props.onHavingTroubleChange(nextHasTrouble);
    } else if (typeof props.setMNFMemberInfoData === "function") {
      props.setMNFMemberInfoData({
        ...props.MNFMemberInfoData,
        havingTrouble: nextHasTrouble,
      });
    }
  };

  const onChangePurchaseDate = (e) => {
    const purchaseDate = e.target.value;
    const covered = isPurchaseDateCovered(purchaseDate, numberOfDays);

    devLog("purchase date change:", { purchaseDate, numberOfDays, covered });

    if (typeof props.setMNFMemberInfoData === "function") {
      props.setMNFMemberInfoData({
        ...props.MNFMemberInfoData,
        purchaseDate,
        covered,
      });
    }
  };

  return (
    <>
      <div className="formContainer">
        {accountInfo && displaySelectionComponent && !yesHasTrouble ? (
          <div className="policyData">
            <div className="policyHeader">
              <h4>{t("description.MemberDetails")}</h4>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.Name")}:</b>{" "}
                {accountInfo.firstName && accountInfo.lastName
                  ? accountInfo.firstName + " " + accountInfo.lastName
                  : contacts[0]
                    ? contacts[0].firstName + " " + contacts[0].lastName
                    : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("description.ConfirmCustomerPhoneNumber")}:</b>{" "}
                {accountInfo.phoneNumber ? accountInfo.phoneNumber : contacts[0] ? contacts[0].phoneNumber : ""}
              </div>
              <hr />
              <div className="policy-info-line">
                <b>{t("CRR.ContractSearch.DropdownOptions3")}:</b>{" "}
                {accountInfo.memberNumber ? accountInfo.memberNumber : contacts[0] ? contacts[0].memberNumber : ""}
              </div>
              <hr />
            </div>
          </div>
        ) : (
          <></>
        )}

        {contacts.length > 0 && !error && displaySelectionComponent && (
          <>
            <FormControl
              className="existing-driver-FormControl"
              fullWidth={true}
              style={{
                backgroundColor: "white",
                paddingLeft: "15px",
                paddingRight: "15px",
                paddingTop: "10px",
                paddingBottom: "10px",
              }}
            >
              <h4 id="demo-radio-buttons-group-label">{t("description.ContactInformationHeader")}</h4>
              <hr />
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
                className="existing-driver-radio"
              >
                {contacts.map((contact, index) => {
                  return (
                    <FormControlLabel
                      value={contact}
                      key={index}
                      control={<Radio />}
                      label={contact.firstName + " " + contact.lastName}
                      onClick={(e) => {
                        onSelect(contact);
                      }}
                      checked={selectedContact === contact ? "selected" : ""}
                      sx={{ fontWeight: "bold" }}
                    />
                  );
                })}
              </RadioGroup>
            </FormControl>
          </>
        )}

        {accountInfo && !checkDuplicateName && !error && displaySelectionComponent && (
          <FormControl
            className="existing-driver-FormControl"
            fullWidth={true}
            style={{
              backgroundColor: "white",
              paddingLeft: "15px",
              paddingRight: "15px",
              paddingTop: "10px",
              paddingBottom: "10px",
            }}
          >
            <h4 id="add-contact-buttons-group-label">{t("description.AddContactInformationHeader")}</h4>
            <hr />
            <RadioGroup
              aria-labelledby="add-contact-buttons-group-label"
              name="radio-buttons-group"
              className="existing-driver-radio"
            >
              <FormControlLabel
                value={undefined}
                control={<Radio />}
                label={props.currState.FirstName + " " + props.currState.LastName}
                onClick={() => onSelect(undefined)}
                checked={selectedContact === undefined}
                sx={{ fontWeight: "bold" }}
              />
            </RadioGroup>
          </FormControl>
        )}
      </div>
      {error ? (
        <div className="errorSectionCYSU">
          <b className="error" style={{ color: "red" }}>
            {error}
          </b>
          <div className="member-search-failing-section">
            <h6>{t("description.TroubleFindingAccount")}</h6>
            <div className="member-search-failing-actions">
              <button
                type="button"
                className={`member-search-failing-btn ${
                  yesHasTrouble ? "member-search-failing-btn--primary" : "member-search-failing-btn--secondary"
                }`}
                onClick={onClickYesHasTrouble}
              >
                {t("description.Yes")}
              </button>
              <button
                type="button"
                className="member-search-failing-btn member-search-failing-btn--secondary"
                onClick={onUserBack}
              >
                {t("description.SearchAgain")}
              </button>
            </div>
          </div>
          {yesHasTrouble && (
            <div className="member-search-failing-section new-contact-input-container" style={{ paddingTop: "1rem" }}>
              {/* need to review the wording */}
              <h6 style={{ marginBottom: "0" }}>{t("description.FillUpInformation")}</h6>
              {/* First Name */}
              <FormControl error={error} className="MNF-input-box">
                <TextField
                  id="outlined-basic-firstName"
                  label="First Name"
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  value={props.MNFMemberInfoData.firstName}
                  type="string"
                  onChange={(e) => {
                    devLog("target value change: ", e.target.value);
                    props.setMNFMemberInfoData({
                      ...props.MNFMemberInfoData,
                      firstName: e.target.value,
                    });
                  }}
                />
              </FormControl>

              {/* Last Name */}
              <FormControl error={error} className="MNF-input-box">
                <TextField
                  id="outlined-basic-lastName"
                  label="Last Name"
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  value={props.MNFMemberInfoData.lastName}
                  type="string"
                  onChange={(e) => {
                    devLog("target value change: ", e.target.value);
                    props.setMNFMemberInfoData({
                      ...props.MNFMemberInfoData,
                      lastName: e.target.value,
                    });
                  }}
                />
              </FormControl>

              {/* Phone Number */}
              <FormControl error={error} className="MNF-input-box">
                <TextField
                  id="outlined-basic-phoneNumber"
                  label="Phone Number"
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  value={props.MNFMemberInfoData.phoneNumber}
                  type="string"
                  onChange={(e) => {
                    devLog("target value change: ", e.target.value);
                    props.setMNFMemberInfoData({
                      ...props.MNFMemberInfoData,
                      phoneNumber: e.target.value,
                    });
                  }}
                />
              </FormControl>

              {/* Contract Number */}
              <FormControl error={error} className="MNF-input-box">
                <TextField
                  id="outlined-basic-memberNumber"
                  label="Contract Number"
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  value={props.MNFMemberInfoData.memberNumber}
                  type="string"
                  onChange={(e) => {
                    devLog("target value change: ", e.target.value);
                    props.setMNFMemberInfoData({
                      ...props.MNFMemberInfoData,
                      memberNumber: e.target.value,
                    });
                  }}
                />
              </FormControl>

              {/* Last 8 VIN */}
              <FormControl error={error} className="MNF-input-box">
                <TextField
                  id="outlined-basic-last8Vin"
                  label="Last 8 VIN"
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  value={props.MNFMemberInfoData.last8Vin}
                  type="string"
                  onChange={(e) => {
                    devLog("target value change: ", e.target.value);
                    props.setMNFMemberInfoData({
                      ...props.MNFMemberInfoData,
                      last8Vin: e.target.value,
                    });
                  }}
                />
              </FormControl>

              {/* Purchase Date */}
              <FormControl error={error} className="MNF-input-box">
                <TextField
                  id="outlined-basic-purchaseDate"
                  label="Purchase Date"
                  variant="outlined"
                  size="small"
                  fullWidth={true}
                  value={props.MNFMemberInfoData.purchaseDate}
                  type="date"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{ max: getTodayDateString() }}
                  onChange={onChangePurchaseDate}
                />
              </FormControl>
            </div>
          )}
        </div>
      ) : (
        <></>
      )}

      {loading ? <PolicyLookupSpinner title={`ContractLookupTitleBWC`} message={`PolicyLookupMessage`} /> : <></>}
    </>
  );
}
